import SmartImage from "../../../components/reusables/smartImage";
import NoPictureWarning from "../../../resources/nopic.png";
import { formatCurrency } from "../../../utils/CurrencyUtils";

const CustomerCard = ({ item, clientType, onClick }) => {
    const baseUrl = "/foodz/api/v1/uploads/carregarImagemDePerfil";
    const imageBaseUrl = `${baseUrl}?path=${encodeURIComponent(item.image_url)}`;

    return (
        <div
            onClick={() => onClick(item)}
            className="group relative aspect-[5/5] bg-slate-100 rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 cursor-pointer border border-gray-100"
        >
            <div className="absolute inset-0 w-full h-full">
                {item.image_url ? (
                    <SmartImage
                        src={imageBaseUrl}
                        alt={item.name}
                        type="profile"
                        isThumb={true}
                        className="object-cover"
                    />
                ) : (
                    <img
                        src={NoPictureWarning}
                        className="absolute inset-0 w-full h-full object-contain p-12 opacity-20"
                        alt="Sem foto"
                    />
                )}
            </div>

            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent opacity-80" />

            <div className="absolute top-3 left-3 z-10 flex flex-col gap-1">
                <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold text-white ${item.user_status ? 'bg-green-500' : 'bg-red-500'}`}>
                    {item.user_status ? 'ATIVO' : 'INATIVO'}
                </span>
            </div>

            <div className="absolute bottom-0 left-0 w-full p-4 text-white z-10">
                <p className="font-bold text-base leading-tight truncate drop-shadow-md">{item.name}</p>
                <span className="text-[10px] text-gray-300 uppercase tracking-widest">
                    {clientType === 'students' ? formatCurrency(item.credit) : item.login}
                </span>
            </div>
        </div>
    );
};

export default CustomerCard;